<template>
  <Layout :version="menu_version" />
</template>

<script>

import Layout from "./Layout/index.vue";
import globalTheme from "Assets/js/components/globalTheme";

export default {
  name: "MainMenu",
  components: {
    Layout
  },
  data() {
    return {
      menu_version: 'v1'
    }
  },
  beforeMount() {
    this.feature_enabled = globalTheme.featureEnabled();
    if( this.feature_enabled?.navigation?.version === 2 ){
      this.menu_version = 'v2';
    }
  }
};
</script>
